import { useEffect, useRef } from 'react'

type KeysToActions = Record<string, () => void>

export default function useKeyPressed(initKeysToActions: KeysToActions): void {
  const keysToActions = useRef(initKeysToActions)
  useEffect(() => {
    function handler({ key }: KeyboardEvent): void {
      Object.keys(keysToActions.current).forEach(keyToAction => {
        if (key === keyToAction) {
          keysToActions.current[keyToAction]()
        }
      })
    }
    window.addEventListener('keydown', handler)
    return () => {
      window.removeEventListener('keydown', handler)
    }
  }, [keysToActions])
}
